export default __webpack_public_path__ + "static/media/Supervity-Guidelines.7693b4c1.docx";